import generateFilterModule from './generateFilterModule'

export default generateFilterModule('myschedule')
